import React, { useEffect, useMemo, useState, Component } from 'react';
import { DollarSign, Eye, MousePointer, TrendingUp, ShoppingCart, AlertTriangle, Clock, Calendar as CalendarIcon, Download, RefreshCw, Target, Zap, ArrowUpRight, ArrowDownRight, X, Search, Crown, Star, Activity, Layers, ChevronRight, Info, AlertCircle, BarChart3, PieChart as PieChartIcon, Radio, ChevronDown, ExternalLink, ChevronLeft, Check, Loader2, FileText, Mail } from 'lucide-react';
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, ComposedChart, Bar, Line, PieChart, Pie, Cell } from 'recharts';
import { Card } from '../ui/Card';
import { Button } from '../ui/Button';
import { Badge } from '../ui/Badge';
// ─── Types ───────────────────────────────────────────────
interface AdAnalyticsDashboardProps {
  placements: any[];
  slotsData: any[];
  setActiveTab: (tab: string) => void;
  setDetailPanel: (panel: any) => void;
  success: (msg: string) => void;
}
interface DrillDownModal {
  title: string;
  type: string;
  data?: any[];
}
// ─── Mock Data ───────────────────────────────────────────
const TREND_DATA = [{
  date: '01',
  revenue: 12000,
  impressions: 4500,
  clicks: 120
}, {
  date: '02',
  revenue: 15000,
  impressions: 5200,
  clicks: 140
}, {
  date: '03',
  revenue: 11000,
  impressions: 4100,
  clicks: 110
}, {
  date: '04',
  revenue: 18000,
  impressions: 6000,
  clicks: 180
}, {
  date: '05',
  revenue: 22000,
  impressions: 7500,
  clicks: 220
}, {
  date: '06',
  revenue: 19000,
  impressions: 6800,
  clicks: 190
}, {
  date: '07',
  revenue: 25000,
  impressions: 8200,
  clicks: 250
}, {
  date: '08',
  revenue: 21000,
  impressions: 7100,
  clicks: 210
}, {
  date: '09',
  revenue: 28000,
  impressions: 9400,
  clicks: 310
}, {
  date: '10',
  revenue: 24000,
  impressions: 8000,
  clicks: 260
}, {
  date: '11',
  revenue: 30000,
  impressions: 10200,
  clicks: 340
}, {
  date: '12',
  revenue: 26000,
  impressions: 8800,
  clicks: 290
}, {
  date: '13',
  revenue: 32000,
  impressions: 11000,
  clicks: 380
}, {
  date: '14',
  revenue: 29000,
  impressions: 9600,
  clicks: 320
}];
const PIE_COLORS = ['#6366f1', '#8b5cf6', '#3b82f6', '#10b981', '#f59e0b', '#ec4899'];
const FORMAT_DATA = [{
  name: 'Баннеры',
  revenue: 187000,
  pct: 44,
  ctr: 3.24,
  benchmark: 3.0,
  delta: '+12%',
  impressions: 245000,
  clicks: 7938,
  color: 'bg-indigo-500',
  pieColor: '#6366f1'
}, {
  name: 'Закреп астрологов',
  revenue: 98000,
  pct: 23,
  ctr: 5.02,
  benchmark: 4.5,
  delta: '+8%',
  impressions: 89000,
  clicks: 4468,
  color: 'bg-purple-500',
  pieColor: '#8b5cf6'
}, {
  name: 'Закреп курсов',
  revenue: 62000,
  pct: 15,
  ctr: 5.5,
  benchmark: 4.5,
  delta: '+15%',
  impressions: 54000,
  clicks: 2970,
  color: 'bg-blue-500',
  pieColor: '#3b82f6'
}, {
  name: 'Email',
  revenue: 38800,
  pct: 9,
  ctr: 7.54,
  benchmark: 6.0,
  delta: '-3%',
  impressions: 32000,
  clicks: 2413,
  color: 'bg-emerald-500',
  pieColor: '#10b981'
}, {
  name: 'Promo',
  revenue: 24000,
  pct: 6,
  ctr: 2.1,
  benchmark: 3.0,
  delta: '+22%',
  impressions: 48000,
  clicks: 1008,
  color: 'bg-amber-500',
  pieColor: '#f59e0b'
}, {
  name: 'Native',
  revenue: 16000,
  pct: 3,
  ctr: 4.8,
  benchmark: 4.0,
  delta: '+5%',
  impressions: 18000,
  clicks: 864,
  color: 'bg-pink-500',
  pieColor: '#ec4899'
}];
const TOP_ADVERTISERS = [{
  name: 'Astriqo Premium — Sticky',
  type: 'Внешний',
  campaigns: 4,
  revenue: 120000,
  ctr: 3.24,
  conversions: 245
}, {
  name: 'TaroMaster',
  type: 'Внешний',
  campaigns: 2,
  revenue: 65000,
  ctr: 2.8,
  conversions: 120
}, {
  name: 'Мария Звёздная',
  type: 'Астролог',
  campaigns: 3,
  revenue: 45000,
  ctr: 5.02,
  conversions: 89
}, {
  name: 'AI Tech',
  type: 'Внешний',
  campaigns: 1,
  revenue: 50000,
  ctr: 1.9,
  conversions: 45
}, {
  name: 'MercuryApp',
  type: 'Внешний',
  campaigns: 2,
  revenue: 44000,
  ctr: 4.19,
  conversions: 78
}];
const TOP_CAMPAIGNS = [{
  id: 'PLC-101',
  name: 'AstroSchool — TOP баннер',
  format: 'Баннер',
  slot: 'Главная TOP',
  impressions: 38420,
  clicks: 1245,
  ctr: 3.24,
  revenue: 45000
}, {
  id: 'PLC-113',
  name: 'MoonPhase — Лунный календарь',
  format: 'Баннер',
  slot: 'Лунный календарь',
  impressions: 30000,
  clicks: 900,
  ctr: 3.0,
  revenue: 22400
}, {
  id: 'PLC-110',
  name: 'ZodiacApp — Гороскоп',
  format: 'Native',
  slot: 'Гороскоп',
  impressions: 45000,
  clicks: 2025,
  ctr: 4.5,
  revenue: 32400
}, {
  id: 'PLC-111',
  name: 'AstroReport Pro',
  format: 'Native',
  slot: 'Бесплатная карта',
  impressions: 12000,
  clicks: 720,
  ctr: 6.0,
  revenue: 48400
}, {
  id: 'PLC-115',
  name: 'Astriqo Premium — Sticky',
  format: 'Баннер',
  slot: 'Мобильный sticky',
  impressions: 450000,
  clicks: 4500,
  ctr: 1.0,
  revenue: 60000
}];
const TOP_ASTROLOGERS = [{
  name: 'Мария Звёздная',
  impressions: 8200,
  clicks: 412,
  ctr: 5.02,
  bookings: 45,
  revenue: 15000,
  cr: 10.9
}, {
  name: 'Виктория Небесная',
  impressions: 6400,
  clicks: 320,
  ctr: 5.0,
  bookings: 32,
  revenue: 15000,
  cr: 10.0
}, {
  name: 'Алексей Лунный',
  impressions: 5100,
  clicks: 255,
  ctr: 5.0,
  bookings: 28,
  revenue: 12000,
  cr: 11.0
}];
const WORST_CAMPAIGNS = [{
  id: 'PLC-108',
  name: 'MoonApp — Сайдбар',
  issue: 'Приостановлена, 0 кликов за 5 дней',
  severity: 'critical' as const
}, {
  id: 'PLC-107',
  name: 'Tarot School — TOP баннер',
  issue: 'Не оплачено, старт через 2 дня',
  severity: 'critical' as const
}, {
  id: 'PLC-104',
  name: 'Курс Таро — Promo',
  issue: 'Ожидает оплаты',
  severity: 'high' as const
}, {
  id: 'PLC-115',
  name: 'Astriqo Premium — Sticky',
  issue: 'CTR 1.00% — ниже нормы',
  severity: 'medium' as const
}];
const ALERTS = [{
  id: 1,
  severity: 'critical' as const,
  message: 'SLOT-04 "Топ каталога" перегружен — очередь 15',
  action: 'queue'
}, {
  id: 2,
  severity: 'critical' as const,
  message: 'SLOT-02 "Сайдбар каталога" пуст — потеря ₽20,000/мес',
  action: 'slots'
}, {
  id: 3,
  severity: 'high' as const,
  message: '3 кампании ожидают оплаты более 48 часов',
  action: 'all'
}, {
  id: 4,
  severity: 'medium' as const,
  message: 'Email bounce rate выше нормы (4.2%)',
  action: 'email'
}, {
  id: 5,
  severity: 'low' as const,
  message: 'Слот "Блог — сайдбар" заполнен на 50%',
  action: 'slots'
}];
const SLOT_TABLE = [{
  id: 'SLOT-02',
  name: 'Сайдбар каталога',
  page: 'Каталог',
  revenue: 0,
  impressions: 0,
  clicks: 0,
  ctr: 0,
  fillRate: 0,
  queue: 0,
  potential: 40000,
  lost: 40000
}, {
  id: 'SLOT-03',
  name: 'Внутри статьи',
  page: 'Блог',
  revenue: 12000,
  impressions: 45000,
  clicks: 1250,
  ctr: 2.77,
  fillRate: 33,
  queue: 0,
  potential: 36000,
  lost: 24000
}, {
  id: 'SLOT-04',
  name: 'Топ каталога',
  page: 'Каталог',
  revenue: 45000,
  impressions: 89000,
  clicks: 6700,
  ctr: 7.52,
  fillRate: 100,
  queue: 15,
  potential: 45000,
  lost: 0
}, {
  id: 'SLOT-06',
  name: 'Гороскоп — баннер',
  page: 'Гороскоп',
  revenue: 36000,
  impressions: 32000,
  clicks: 1440,
  ctr: 4.5,
  fillRate: 50,
  queue: 0,
  potential: 36000,
  lost: 18000
}, {
  id: 'SLOT-08',
  name: 'После бесплатной карты',
  page: 'Бесплатная карта',
  revenue: 44000,
  impressions: 9500,
  clicks: 570,
  ctr: 6.0,
  fillRate: 100,
  queue: 0,
  potential: 44000,
  lost: 0
}, {
  id: 'SLOT-11',
  name: 'Лунный календарь',
  page: 'Лунный календарь',
  revenue: 24000,
  impressions: 28000,
  clicks: 840,
  ctr: 3.0,
  fillRate: 50,
  queue: 0,
  potential: 28000,
  lost: 14000
}];
const LOST_REVENUE = [{
  label: 'Пустые слоты',
  value: 68000,
  icon: <Layers className="w-4 h-4" data-id="element-92" />,
  color: 'text-rose-600 bg-rose-50'
}, {
  label: 'Неоплаченные кампании',
  value: 45000,
  icon: <Clock className="w-4 h-4" data-id="element-93" />,
  color: 'text-amber-600 bg-amber-50'
}, {
  label: 'Конфликты / ошибки',
  value: 12200,
  icon: <AlertTriangle className="w-4 h-4" data-id="element-94" />,
  color: 'text-orange-600 bg-orange-50'
}, {
  label: 'Слабый fill rate',
  value: 29000,
  icon: <Target className="w-4 h-4" data-id="element-95" />,
  color: 'text-purple-600 bg-purple-50'
}];
const CALENDAR_DATA: Record<number, {
  active: number;
  scheduled: number;
  email: number;
  overloaded: boolean;
}> = {
  1: {
    active: 2,
    scheduled: 1,
    email: 0,
    overloaded: false
  },
  2: {
    active: 2,
    scheduled: 1,
    email: 0,
    overloaded: false
  },
  3: {
    active: 3,
    scheduled: 0,
    email: 1,
    overloaded: false
  },
  5: {
    active: 3,
    scheduled: 2,
    email: 0,
    overloaded: false
  },
  6: {
    active: 4,
    scheduled: 1,
    email: 0,
    overloaded: false
  },
  7: {
    active: 4,
    scheduled: 0,
    email: 0,
    overloaded: false
  },
  8: {
    active: 3,
    scheduled: 0,
    email: 0,
    overloaded: false
  },
  10: {
    active: 5,
    scheduled: 1,
    email: 0,
    overloaded: true
  },
  11: {
    active: 5,
    scheduled: 0,
    email: 0,
    overloaded: true
  },
  12: {
    active: 4,
    scheduled: 0,
    email: 0,
    overloaded: false
  },
  13: {
    active: 5,
    scheduled: 1,
    email: 0,
    overloaded: true
  },
  14: {
    active: 4,
    scheduled: 0,
    email: 0,
    overloaded: false
  },
  15: {
    active: 3,
    scheduled: 0,
    email: 1,
    overloaded: false
  },
  16: {
    active: 3,
    scheduled: 0,
    email: 0,
    overloaded: false
  },
  17: {
    active: 4,
    scheduled: 2,
    email: 0,
    overloaded: false
  },
  18: {
    active: 4,
    scheduled: 1,
    email: 0,
    overloaded: false
  },
  19: {
    active: 3,
    scheduled: 0,
    email: 0,
    overloaded: false
  },
  20: {
    active: 5,
    scheduled: 2,
    email: 0,
    overloaded: true
  },
  21: {
    active: 4,
    scheduled: 1,
    email: 0,
    overloaded: false
  },
  22: {
    active: 3,
    scheduled: 0,
    email: 0,
    overloaded: false
  },
  24: {
    active: 3,
    scheduled: 0,
    email: 0,
    overloaded: false
  },
  25: {
    active: 2,
    scheduled: 1,
    email: 0,
    overloaded: false
  },
  26: {
    active: 2,
    scheduled: 0,
    email: 0,
    overloaded: false
  },
  27: {
    active: 3,
    scheduled: 1,
    email: 0,
    overloaded: false
  },
  28: {
    active: 3,
    scheduled: 0,
    email: 1,
    overloaded: false
  },
  29: {
    active: 2,
    scheduled: 0,
    email: 0,
    overloaded: false
  },
  30: {
    active: 2,
    scheduled: 0,
    email: 0,
    overloaded: false
  },
  31: {
    active: 1,
    scheduled: 0,
    email: 0,
    overloaded: false
  }
};
// ─── Helpers ─────────────────────────────────────────────
const fmtCurrency = (v: number) => new Intl.NumberFormat('ru-RU', {
  style: 'currency',
  currency: 'RUB',
  maximumFractionDigits: 0
}).format(v);
const fmtNum = (v: number) => new Intl.NumberFormat('ru-RU').format(v);
const severityConfig = {
  critical: {
    bg: 'bg-rose-50',
    border: 'border-rose-200',
    text: 'text-rose-700',
    badge: 'error' as const,
    label: 'Критично'
  },
  high: {
    bg: 'bg-amber-50',
    border: 'border-amber-200',
    text: 'text-amber-700',
    badge: 'warning' as const,
    label: 'Высокий'
  },
  medium: {
    bg: 'bg-yellow-50',
    border: 'border-yellow-200',
    text: 'text-yellow-700',
    badge: 'warning' as const,
    label: 'Средний'
  },
  low: {
    bg: 'bg-slate-50',
    border: 'border-slate-200',
    text: 'text-slate-600',
    badge: 'neutral' as const,
    label: 'Низкий'
  }
};
// ─── Component ───────────────────────────────────────────
export function AdAnalyticsDashboard({
  placements,
  slotsData,
  setActiveTab,
  setDetailPanel,
  success
}: AdAnalyticsDashboardProps) {
  const [filters, setFilters] = useState({
    period: '30d',
    type: 'all',
    status: 'all',
    payment: 'all',
    slot: 'all',
    advertiserType: 'all'
  });
  const [showFilters, setShowFilters] = useState(false);
  const [drillDown, setDrillDown] = useState<DrillDownModal | null>(null);
  const [liveData, setLiveData] = useState({
    impressions: 652420,
    clicks: 18267,
    active: 8
  });
  const [slotSort, setSlotSort] = useState<{
    key: string;
    dir: 'asc' | 'desc';
  }>({
    key: 'revenue',
    dir: 'desc'
  });
  const [advSortBy, setAdvSortBy] = useState<'revenue' | 'ctr' | 'conversions'>('revenue');
  const [campSortBy, setCampSortBy] = useState<'ctr' | 'revenue' | 'clicks'>('revenue');
  // Calendar state
  const [calendarMonth, setCalendarMonth] = useState(2); // 0-indexed: 2 = March
  const [calendarYear, setCalendarYear] = useState(2026);
  const [calendarFilter, setCalendarFilter] = useState<'all' | 'active' | 'scheduled' | 'email' | 'overloaded'>('all');
  // Export state
  const [exportLoading, setExportLoading] = useState<string | null>(null);
  const [showScheduleModal, setShowScheduleModal] = useState(false);
  const [scheduleConfig, setScheduleConfig] = useState({
    frequency: 'weekly',
    format: 'xlsx',
    email: 'admin@astriqo.com',
    day: 'monday'
  });
  // Live simulation
  useEffect(() => {
    const interval = setInterval(() => {
      setLiveData(prev => ({
        impressions: prev.impressions + Math.floor(Math.random() * 80),
        clicks: prev.clicks + Math.floor(Math.random() * 8),
        active: prev.active + (Math.random() > 0.92 ? 1 : 0) - (Math.random() > 0.95 ? 1 : 0)
      }));
    }, 5000);
    return () => clearInterval(interval);
  }, []);
  // Calendar helpers
  const MONTH_NAMES = ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'];
  const getDaysInMonth = (month: number, year: number) => new Date(year, month + 1, 0).getDate();
  const getFirstDayOfWeek = (month: number, year: number) => {
    const day = new Date(year, month, 1).getDay();
    return day === 0 ? 6 : day - 1; // Convert to Monday-start (0=Mon, 6=Sun)
  };
  const goToPrevMonth = () => {
    if (calendarMonth === 0) {
      setCalendarMonth(11);
      setCalendarYear(y => y - 1);
    } else {
      setCalendarMonth(m => m - 1);
    }
  };
  const goToNextMonth = () => {
    if (calendarMonth === 11) {
      setCalendarMonth(0);
      setCalendarYear(y => y + 1);
    } else {
      setCalendarMonth(m => m + 1);
    }
  };
  const goToCurrentMonth = () => {
    setCalendarMonth(2); // March 2026
    setCalendarYear(2026);
  };
  const isCurrentMonth = calendarMonth === 2 && calendarYear === 2026;
  // Export handlers
  const handleExport = (format: string) => {
    setExportLoading(format);
    setTimeout(() => {
      setExportLoading(null);
      success(`Файл ${format.toUpperCase()} (${MONTH_NAMES[calendarMonth]} ${calendarYear}) скачан — ad_analytics_${filters.period}.${format}`);
    }, 1800);
  };
  const handleScheduleExport = () => {
    setShowScheduleModal(false);
    success(`Запланирован ${scheduleConfig.frequency === 'weekly' ? 'еженедельный' : scheduleConfig.frequency === 'daily' ? 'ежедневный' : 'ежемесячный'} отчёт (${scheduleConfig.format.toUpperCase()}) на ${scheduleConfig.email}`);
  };
  // Computed
  const totalRevenue = 425800;
  const totalImpressions = 652420;
  const totalClicks = 18267;
  const avgCtr = '2.80';
  const totalConversions = 1545;
  const fillRate = 78;
  const activePlacements = 8;
  const queuedCount = 5;
  const pendingPaymentCount = 2;
  const potentialRevenue = 580000;
  const totalLostRevenue = 154200;
  const errorCount = 3;
  const sortedSlots = useMemo(() => {
    return [...SLOT_TABLE].sort((a, b) => {
      const av = (a as any)[slotSort.key] ?? 0;
      const bv = (b as any)[slotSort.key] ?? 0;
      return slotSort.dir === 'desc' ? bv - av : av - bv;
    });
  }, [slotSort]);
  const sortedAdvertisers = useMemo(() => {
    return [...TOP_ADVERTISERS].sort((a, b) => (b as any)[advSortBy] - (a as any)[advSortBy]);
  }, [advSortBy]);
  const sortedCampaigns = useMemo(() => {
    return [...TOP_CAMPAIGNS].sort((a, b) => (b as any)[campSortBy] - (a as any)[campSortBy]);
  }, [campSortBy]);
  const handleSlotSort = (key: string) => {
    setSlotSort(prev => ({
      key,
      dir: prev.key === key && prev.dir === 'desc' ? 'asc' : 'desc'
    }));
  };
  const openDrill = (title: string, type: string, data?: any[]) => {
    setDrillDown({
      title,
      type,
      data
    });
  };
  const periods = [{
    id: 'today',
    label: 'Сегодня'
  }, {
    id: 'yesterday',
    label: 'Вчера'
  }, {
    id: '7d',
    label: '7 дней'
  }, {
    id: '30d',
    label: '30 дней'
  }, {
    id: 'quarter',
    label: 'Квартал'
  }, {
    id: 'year',
    label: 'Год'
  }];
  // ─── Section Header Helper ──────────────────────────────
  const SectionHeader = ({
    title,
    icon,
    tab,
    buttonLabel
  }: {
    title: string;
    icon: React.ReactNode;
    tab?: string;
    buttonLabel?: string;
  }) => <div className="flex items-center justify-between mb-4" data-id="element-96">
      <h3 className="text-sm font-bold text-slate-900 flex items-center gap-2" data-id="element-97">
        {icon} {title}
      </h3>
      {tab && <Button variant="ghost" size="sm" className="text-xs text-indigo-600 hover:text-indigo-800" onClick={() => setActiveTab(tab)} data-id="element-98">
          {buttonLabel || 'Подробнее'} <ExternalLink className="w-3 h-3 ml-1" data-id="element-99" />
        </Button>}
    </div>;
  // ─── KPI Card ──────────────────────────────────────────
  const KpiCard = ({
    label,
    value,
    icon,
    bg,
    trend,
    trendPositive,
    onClick
  }: {
    label: string;
    value: string;
    icon: React.ReactNode;
    bg: string;
    trend?: string;
    trendPositive?: boolean;
    onClick?: () => void;
  }) => <Card padding="sm" hoverable className="rounded-xl shadow-none border-slate-200 p-3.5 flex flex-col justify-between h-[88px] cursor-pointer group transition-all hover:border-indigo-300 hover:shadow-md" onClick={onClick} data-id="element-100">
      <div className="flex justify-between items-start" data-id="element-101">
        <div className={`w-7 h-7 rounded-lg ${bg} flex items-center justify-center group-hover:scale-110 transition-transform`} data-id="element-102">
          {icon}
        </div>
        {trend && <span className={`text-[10px] font-semibold flex items-center gap-0.5 ${trendPositive ? 'text-emerald-600' : 'text-rose-500'}`} data-id="element-103">
            {trendPositive ? <ArrowUpRight className="w-3 h-3" data-id="element-104" /> : <ArrowDownRight className="w-3 h-3" data-id="element-105" />}
            {trend}
          </span>}
      </div>
      <div data-id="element-106">
        <div className="text-[10px] text-slate-500 font-medium" data-id="element-107">{label}</div>
        <div className="text-lg font-bold text-slate-900 leading-tight" data-id="element-108">
          {value}
        </div>
      </div>
    </Card>;
  // ─── Render ────────────────────────────────────────────
  return <div className="space-y-5" data-id="element-109">
      {/* ═══ FILTERS BAR ═══ */}
      <div className="bg-white rounded-xl border border-slate-200 p-3" data-id="element-110">
        <div className="flex flex-wrap items-center gap-2" data-id="element-111">
          {/* Period pills */}
          <div className="flex items-center gap-1 bg-slate-100 p-0.5 rounded-lg" data-id="element-112">
            {periods.map(p => <button key={p.id} onClick={() => setFilters(f => ({
            ...f,
            period: p.id
          }))} className={`px-2.5 py-1 rounded-md text-xs font-medium transition-all ${filters.period === p.id ? 'bg-white text-indigo-700 shadow-sm' : 'text-slate-500 hover:text-slate-700'}`} data-id="element-113">
                {p.label}
              </button>)}
          </div>

          <div className="flex-1" data-id="element-114" />

          {/* Live indicator */}
          <div className="flex items-center gap-2 bg-emerald-50 border border-emerald-200 rounded-lg px-3 py-1.5" data-id="element-115">
            <span className="relative flex h-2 w-2" data-id="element-116">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75" data-id="element-117" />
              <span className="relative inline-flex rounded-full h-2 w-2 bg-emerald-500" data-id="element-118" />
            </span>
            <span className="text-[10px] font-bold text-emerald-700" data-id="element-119">LIVE</span>
            <span className="text-[10px] text-emerald-600" data-id="element-120">
              {fmtNum(liveData.impressions)} показов
            </span>
            <span className="text-[10px] text-emerald-600" data-id="element-121">·</span>
            <span className="text-[10px] text-emerald-600" data-id="element-122">
              {fmtNum(liveData.clicks)} кликов
            </span>
          </div>

          <Button variant="outline" size="sm" icon={<Search className="w-3.5 h-3.5" data-id="element-124" />} onClick={() => setShowFilters(!showFilters)} data-id="element-123">
            Фильтры {showFilters ? '▲' : '▼'}
          </Button>
          <Button variant="outline" size="sm" icon={<Download className="w-3.5 h-3.5" data-id="element-126" />} onClick={() => success('Экспорт данных начат')} data-id="element-125">
            Экспорт
          </Button>
        </div>

        {/* Expanded filters */}
        {showFilters && <div className="mt-3 pt-3 border-t border-slate-100 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-6 gap-3" data-id="element-127">
            <div data-id="element-128">
              <label className="block text-[10px] font-medium text-slate-500 mb-1" data-id="element-129">
                Тип рекламы
              </label>
              <select className="w-full text-xs border border-slate-200 rounded-lg px-2.5 py-1.5 bg-white text-slate-700 focus:outline-none focus:ring-1 focus:ring-indigo-500" value={filters.type} onChange={e => setFilters(f => ({
            ...f,
            type: e.target.value
          }))} data-id="element-130">
                <option value="all" data-id="element-131">Все форматы</option>
                <option value="banner" data-id="element-132">Баннеры</option>
                <option value="pinned_astrologer" data-id="element-133">Закреп астрологов</option>
                <option value="pinned_course" data-id="element-134">Закреп курсов</option>
                <option value="email" data-id="element-135">Email</option>
                <option value="promo" data-id="element-136">Promo</option>
                <option value="native" data-id="element-137">Native</option>
              </select>
            </div>
            <div data-id="element-138">
              <label className="block text-[10px] font-medium text-slate-500 mb-1" data-id="element-139">
                Статус
              </label>
              <select className="w-full text-xs border border-slate-200 rounded-lg px-2.5 py-1.5 bg-white text-slate-700 focus:outline-none focus:ring-1 focus:ring-indigo-500" value={filters.status} onChange={e => setFilters(f => ({
            ...f,
            status: e.target.value
          }))} data-id="element-140">
                <option value="all" data-id="element-141">Все статусы</option>
                <option value="active" data-id="element-142">Активные</option>
                <option value="scheduled" data-id="element-143">Запланированные</option>
                <option value="queued" data-id="element-144">В очереди</option>
                <option value="completed" data-id="element-145">Завершённые</option>
                <option value="paused" data-id="element-146">На паузе</option>
              </select>
            </div>
            <div data-id="element-147">
              <label className="block text-[10px] font-medium text-slate-500 mb-1" data-id="element-148">
                Оплата
              </label>
              <select className="w-full text-xs border border-slate-200 rounded-lg px-2.5 py-1.5 bg-white text-slate-700 focus:outline-none focus:ring-1 focus:ring-indigo-500" value={filters.payment} onChange={e => setFilters(f => ({
            ...f,
            payment: e.target.value
          }))} data-id="element-149">
                <option value="all" data-id="element-150">Все оплаты</option>
                <option value="paid" data-id="element-151">Оплачено</option>
                <option value="pending" data-id="element-152">Ожидает</option>
                <option value="failed" data-id="element-153">Ошибка</option>
                <option value="refunded" data-id="element-154">Возврат</option>
              </select>
            </div>
            <div data-id="element-155">
              <label className="block text-[10px] font-medium text-slate-500 mb-1" data-id="element-156">
                Слот
              </label>
              <select className="w-full text-xs border border-slate-200 rounded-lg px-2.5 py-1.5 bg-white text-slate-700 focus:outline-none focus:ring-1 focus:ring-indigo-500" value={filters.slot} onChange={e => setFilters(f => ({
            ...f,
            slot: e.target.value
          }))} data-id="element-157">
                <option value="all" data-id="element-158">Все слоты</option>
                {SLOT_TABLE.map(s => <option key={s.id} value={s.id} data-id="element-159">
                    {s.name}
                  </option>)}
              </select>
            </div>
            <div data-id="element-160">
              <label className="block text-[10px] font-medium text-slate-500 mb-1" data-id="element-161">
                Тип рекламодателя
              </label>
              <select className="w-full text-xs border border-slate-200 rounded-lg px-2.5 py-1.5 bg-white text-slate-700 focus:outline-none focus:ring-1 focus:ring-indigo-500" value={filters.advertiserType} onChange={e => setFilters(f => ({
            ...f,
            advertiserType: e.target.value
          }))} data-id="element-162">
                <option value="all" data-id="element-163">Все типы</option>
                <option value="astrologer" data-id="element-164">Астрологи</option>
                <option value="user" data-id="element-165">Пользователи</option>
                <option value="external" data-id="element-166">Внешние</option>
              </select>
            </div>
            <div className="flex items-end" data-id="element-167">
              <button className="w-full text-xs text-indigo-600 hover:text-indigo-800 font-medium border border-indigo-200 rounded-lg px-2.5 py-1.5 hover:bg-indigo-50 transition-colors" onClick={() => setFilters({
            period: '30d',
            type: 'all',
            status: 'all',
            payment: 'all',
            slot: 'all',
            advertiserType: 'all'
          })} data-id="element-168">
                Сбросить всё
              </button>
            </div>
          </div>}
      </div>

      {/* ═══ KPI ROW 1 ═══ */}
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3" data-id="element-169">
        <KpiCard label="Доход от рекламы" value={fmtCurrency(totalRevenue)} icon={<DollarSign className="w-3.5 h-3.5 text-emerald-600" data-id="element-171" />} bg="bg-emerald-50" trend="+18%" trendPositive onClick={() => openDrill('Доход от рекламы', 'revenue')} data-id="element-170" />
        <KpiCard label="Всего показов" value={fmtNum(totalImpressions)} icon={<Eye className="w-3.5 h-3.5 text-blue-600" data-id="element-173" />} bg="bg-blue-50" trend="+12%" trendPositive onClick={() => openDrill('Показы', 'impressions')} data-id="element-172" />
        <KpiCard label="Всего кликов" value={fmtNum(totalClicks)} icon={<MousePointer className="w-3.5 h-3.5 text-purple-600" data-id="element-175" />} bg="bg-purple-50" trend="+9%" trendPositive onClick={() => openDrill('Клики', 'clicks')} data-id="element-174" />
        <KpiCard label="Средний CTR" value={`${avgCtr}%`} icon={<TrendingUp className="w-3.5 h-3.5 text-amber-600" data-id="element-177" />} bg="bg-amber-50" trend="-0.3%" trendPositive={false} onClick={() => openDrill('CTR', 'ctr')} data-id="element-176" />
        <KpiCard label="Конверсии" value={fmtNum(totalConversions)} icon={<ShoppingCart className="w-3.5 h-3.5 text-indigo-600" data-id="element-179" />} bg="bg-indigo-50" trend="+15%" trendPositive onClick={() => openDrill('Конверсии', 'conversions')} data-id="element-178" />
        <KpiCard label="Fill Rate" value={`${fillRate}%`} icon={<Target className="w-3.5 h-3.5 text-teal-600" data-id="element-181" />} bg="bg-teal-50" trend="+5%" trendPositive onClick={() => openDrill('Fill Rate', 'fill_rate')} data-id="element-180" />
      </div>

      {/* ═══ KPI ROW 2 ═══ */}
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3" data-id="element-182">
        <KpiCard label="Активные" value={String(activePlacements)} icon={<Activity className="w-3.5 h-3.5 text-emerald-600" data-id="element-184" />} bg="bg-emerald-50" onClick={() => openDrill('Активные кампании', 'active')} data-id="element-183" />
        <KpiCard label="В очереди" value={String(queuedCount)} icon={<Layers className="w-3.5 h-3.5 text-indigo-600" data-id="element-186" />} bg="bg-indigo-50" onClick={() => setActiveTab('queue')} data-id="element-185" />
        <KpiCard label="Потенц. доход" value={fmtCurrency(potentialRevenue)} icon={<Zap className="w-3.5 h-3.5 text-amber-600" data-id="element-188" />} bg="bg-amber-50" onClick={() => openDrill('Потенциальный доход', 'potential')} data-id="element-187" />
        <KpiCard label="Потерянный доход" value={fmtCurrency(totalLostRevenue)} icon={<AlertTriangle className="w-3.5 h-3.5 text-rose-600" data-id="element-190" />} bg="bg-rose-50" onClick={() => openDrill('Потерянный доход', 'lost')} data-id="element-189" />
        <KpiCard label="Ошибки" value={String(errorCount)} icon={<AlertCircle className="w-3.5 h-3.5 text-orange-600" data-id="element-192" />} bg="bg-orange-50" onClick={() => openDrill('Ошибки', 'errors')} data-id="element-191" />
        <KpiCard label="Ожидают оплаты" value={String(pendingPaymentCount)} icon={<Clock className="w-3.5 h-3.5 text-slate-600" data-id="element-194" />} bg="bg-slate-100" onClick={() => openDrill('Ожидают оплаты', 'pending_payment')} data-id="element-193" />
      </div>

      {/* ═══ CHARTS ═══ */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4" data-id="element-195">
        {/* Revenue Trend */}
        <Card padding="md" className="rounded-xl shadow-none border-slate-200 lg:col-span-2" data-id="element-196">
          <SectionHeader title="Доход по дням" icon={<BarChart3 className="w-4 h-4 text-emerald-500" data-id="element-198" />} tab="all" buttonLabel="Все кампании" data-id="element-197" />
          <ResponsiveContainer width="100%" height={220} data-id="element-199">
            <AreaChart data={TREND_DATA} data-id="element-200">
              <defs data-id="element-201">
                <linearGradient id="revGrad" x1="0" y1="0" x2="0" y2="1" data-id="element-202">
                  <stop offset="5%" stopColor="#10b981" stopOpacity={0.3} data-id="element-203" />
                  <stop offset="95%" stopColor="#10b981" stopOpacity={0} data-id="element-204" />
                </linearGradient>
              </defs>
              <CartesianGrid strokeDasharray="3 3" stroke="#f1f5f9" data-id="element-205" />
              <XAxis dataKey="date" tick={{
              fontSize: 10,
              fill: '#94a3b8'
            }} axisLine={false} tickLine={false} data-id="element-206" />
              <YAxis tick={{
              fontSize: 10,
              fill: '#94a3b8'
            }} axisLine={false} tickLine={false} tickFormatter={v => `${v / 1000}k`} data-id="element-207" />
              <Tooltip formatter={(v: number) => fmtCurrency(v)} labelFormatter={l => `День ${l}`} contentStyle={{
              fontSize: 12,
              borderRadius: 8,
              border: '1px solid #e2e8f0'
            }} data-id="element-208" />
              <Area type="monotone" dataKey="revenue" stroke="#10b981" strokeWidth={2} fill="url(#revGrad)" data-id="element-209" />
            </AreaChart>
          </ResponsiveContainer>
        </Card>

        {/* Revenue by Format Pie */}
        <Card padding="md" className="rounded-xl shadow-none border-slate-200" data-id="element-210">
          <SectionHeader title="Доход по форматам" icon={<PieChartIcon className="w-4 h-4 text-indigo-500" data-id="element-212" />} data-id="element-211" />
          <ResponsiveContainer width="100%" height={220} data-id="element-213">
            <PieChart data-id="element-214">
              <Pie data={FORMAT_DATA} cx="50%" cy="50%" innerRadius={55} outerRadius={80} paddingAngle={3} dataKey="revenue" nameKey="name" data-id="element-215">
                {FORMAT_DATA.map((entry, i) => <Cell key={i} fill={entry.pieColor} cursor="pointer" onClick={() => openDrill(`Формат: ${entry.name}`, 'format')} data-id="element-216" />)}
              </Pie>
              <Tooltip formatter={(v: number) => fmtCurrency(v)} contentStyle={{
              fontSize: 11,
              borderRadius: 8,
              border: '1px solid #e2e8f0'
            }} data-id="element-217" />
            </PieChart>
          </ResponsiveContainer>
          <div className="flex flex-wrap gap-x-3 gap-y-1 mt-2 justify-center" data-id="element-218">
            {FORMAT_DATA.map(f => <div key={f.name} className="flex items-center gap-1.5" data-id="element-219">
                <div className={`w-2 h-2 rounded-full ${f.color}`} data-id="element-220" />
                <span className="text-[10px] text-slate-500" data-id="element-221">{f.name}</span>
              </div>)}
          </div>
        </Card>
      </div>

      {/* ═══ IMPRESSIONS / CLICKS CHART ═══ */}
      <Card padding="md" className="rounded-xl shadow-none border-slate-200" data-id="element-222">
        <SectionHeader title="Показы и клики по дням" icon={<Eye className="w-4 h-4 text-blue-500" data-id="element-224" />} tab="all" buttonLabel="Все размещения" data-id="element-223" />
        <ResponsiveContainer width="100%" height={220} data-id="element-225">
          <ComposedChart data={TREND_DATA} data-id="element-226">
            <CartesianGrid strokeDasharray="3 3" stroke="#f1f5f9" data-id="element-227" />
            <XAxis dataKey="date" tick={{
            fontSize: 10,
            fill: '#94a3b8'
          }} axisLine={false} tickLine={false} data-id="element-228" />
            <YAxis yAxisId="left" tick={{
            fontSize: 10,
            fill: '#94a3b8'
          }} axisLine={false} tickLine={false} tickFormatter={v => `${v / 1000}k`} data-id="element-229" />
            <YAxis yAxisId="right" orientation="right" tick={{
            fontSize: 10,
            fill: '#94a3b8'
          }} axisLine={false} tickLine={false} data-id="element-230" />
            <Tooltip contentStyle={{
            fontSize: 12,
            borderRadius: 8,
            border: '1px solid #e2e8f0'
          }} data-id="element-231" />
            <Bar yAxisId="left" dataKey="impressions" fill="#c7d2fe" radius={[4, 4, 0, 0]} name="Показы" data-id="element-232" />
            <Line yAxisId="right" type="monotone" dataKey="clicks" stroke="#6366f1" strokeWidth={2.5} dot={{
            r: 3,
            strokeWidth: 2
          }} name="Клики" data-id="element-233" />
          </ComposedChart>
        </ResponsiveContainer>
      </Card>

      {/* ═══ ALERTS ═══ */}
      {ALERTS.length > 0 && <Card padding="md" className="rounded-xl shadow-none border-slate-200" data-id="element-234">
          <SectionHeader title="Предупреждения" icon={<AlertTriangle className="w-4 h-4 text-amber-500" data-id="element-236" />} data-id="element-235" />
          <div className="flex items-center gap-2 mb-3" data-id="element-237">
            <Badge variant="error" size="sm" data-id="element-238">
              {ALERTS.filter(a => a.severity === 'critical').length} критичных
            </Badge>
            <Badge variant="warning" size="sm" data-id="element-239">
              {ALERTS.filter(a => a.severity === 'high' || a.severity === 'medium').length}{' '}
              важных
            </Badge>
          </div>
          <div className="space-y-2" data-id="element-240">
            {ALERTS.map(alert => {
          const cfg = severityConfig[alert.severity];
          return <div key={alert.id} className={`flex items-center justify-between gap-3 p-2.5 rounded-lg border ${cfg.bg} ${cfg.border}`} data-id="element-241">
                  <div className="flex items-center gap-2 min-w-0" data-id="element-242">
                    <Badge variant={cfg.badge} size="sm" data-id="element-243">
                      {cfg.label}
                    </Badge>
                    <span className={`text-xs ${cfg.text} truncate`} data-id="element-244">
                      {alert.message}
                    </span>
                  </div>
                  <Button variant="ghost" size="sm" className="shrink-0 text-xs" onClick={() => setActiveTab(alert.action)} data-id="element-245">
                    Перейти <ChevronRight className="w-3 h-3 ml-1" data-id="element-246" />
                  </Button>
                </div>;
        })}
          </div>
        </Card>}

      {/* ═══ REVENUE & CTR BY FORMAT ═══ */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4" data-id="element-247">
        {/* Revenue by Format Table */}
        <Card padding="md" className="rounded-xl shadow-none border-slate-200" data-id="element-248">
          <SectionHeader title="Доход по форматам" icon={<DollarSign className="w-4 h-4 text-emerald-500" data-id="element-250" />} tab="all" buttonLabel="Все кампании" data-id="element-249" />
          <div className="space-y-3" data-id="element-251">
            {FORMAT_DATA.map(f => <div key={f.name} className="flex items-center gap-3 cursor-pointer hover:bg-slate-50 rounded-lg p-1.5 -mx-1.5 transition-colors" onClick={() => openDrill(`Формат: ${f.name}`, 'format')} data-id="element-252">
                <span className="text-xs text-slate-600 w-32 shrink-0 font-medium" data-id="element-253">
                  {f.name}
                </span>
                <div className="flex-1 bg-slate-100 rounded-full h-2" data-id="element-254">
                  <div className={`${f.color} h-2 rounded-full transition-all`} style={{
                width: `${f.pct}%`
              }} data-id="element-255" />
                </div>
                <span className="text-xs font-bold text-slate-700 w-20 text-right" data-id="element-256">
                  {fmtCurrency(f.revenue)}
                </span>
                <span className={`text-[10px] font-semibold w-10 text-right ${f.delta.startsWith('+') ? 'text-emerald-600' : 'text-rose-500'}`} data-id="element-257">
                  {f.delta}
                </span>
              </div>)}
          </div>
        </Card>

        {/* CTR by Format */}
        <Card padding="md" className="rounded-xl shadow-none border-slate-200" data-id="element-258">
          <SectionHeader title="CTR по форматам" icon={<TrendingUp className="w-4 h-4 text-amber-500" data-id="element-260" />} tab="all" buttonLabel="Детализация" data-id="element-259" />
          <p className="text-[10px] text-slate-400 mb-4 -mt-2" data-id="element-261">
            Средний CTR системы: 2.80%
          </p>
          <div className="space-y-3" data-id="element-262">
            {FORMAT_DATA.map(f => {
            const diff = f.ctr - f.benchmark;
            const status = diff > 0.5 ? 'success' : diff > -0.5 ? 'warning' : 'error';
            return <div key={f.name} className="flex items-center justify-between py-1.5 cursor-pointer hover:bg-slate-50 rounded-lg px-1.5 -mx-1.5 transition-colors" onClick={() => openDrill(`CTR: ${f.name}`, 'ctr_format')} data-id="element-263">
                  <span className="text-xs text-slate-600 font-medium" data-id="element-264">
                    {f.name}
                  </span>
                  <div className="flex items-center gap-2" data-id="element-265">
                    <Badge variant={status} size="sm" data-id="element-266">
                      {f.ctr}%
                    </Badge>
                    <span className="text-[10px] text-slate-400" data-id="element-267">
                      бенчмарк {f.benchmark}%
                    </span>
                  </div>
                </div>;
          })}
          </div>
        </Card>
      </div>

      {/* ═══ SLOTS TABLE ═══ */}
      <Card padding="md" className="rounded-xl shadow-none border-slate-200" data-id="element-268">
        <SectionHeader title="Слоты и доход" icon={<Layers className="w-4 h-4 text-indigo-500" data-id="element-270" />} tab="slots" buttonLabel="Управление слотами" data-id="element-269" />
        <div className="overflow-x-auto" data-id="element-271">
          <table className="w-full text-xs min-w-[800px]" data-id="element-272">
            <thead data-id="element-273">
              <tr className="border-b border-slate-100" data-id="element-274">
                {[{
                key: 'name',
                label: 'Слот'
              }, {
                key: 'page',
                label: 'Страница'
              }, {
                key: 'revenue',
                label: 'Доход'
              }, {
                key: 'impressions',
                label: 'Показы'
              }, {
                key: 'ctr',
                label: 'CTR'
              }, {
                key: 'fillRate',
                label: 'Fill Rate'
              }, {
                key: 'queue',
                label: 'Очередь'
              }, {
                key: 'lost',
                label: 'Потери'
              }].map(col => <th key={col.key} className="text-left py-2 px-2 text-slate-500 font-medium cursor-pointer hover:text-indigo-600 select-none" onClick={() => handleSlotSort(col.key)} data-id="element-275">
                    <span className="flex items-center gap-1" data-id="element-276">
                      {col.label}
                      {slotSort.key === col.key && <ChevronDown className={`w-3 h-3 transition-transform ${slotSort.dir === 'asc' ? 'rotate-180' : ''}`} data-id="element-277" />}
                    </span>
                  </th>)}
              </tr>
            </thead>
            <tbody data-id="element-278">
              {sortedSlots.map(slot => <tr key={slot.id} className="border-b border-slate-50 hover:bg-slate-50 cursor-pointer transition-colors" onClick={() => openDrill(`Слот: ${slot.name}`, 'slot')} data-id="element-279">
                  <td className="py-2.5 px-2 font-medium text-indigo-600" data-id="element-280">
                    {slot.name}
                  </td>
                  <td className="py-2.5 px-2 text-slate-500" data-id="element-281">{slot.page}</td>
                  <td className="py-2.5 px-2 font-bold text-slate-900" data-id="element-282">
                    {fmtCurrency(slot.revenue)}
                  </td>
                  <td className="py-2.5 px-2 text-slate-600" data-id="element-283">
                    {fmtNum(slot.impressions)}
                  </td>
                  <td className="py-2.5 px-2" data-id="element-284">
                    <span className={slot.ctr > 3 ? 'text-emerald-600 font-semibold' : slot.ctr > 0 ? 'text-slate-600' : 'text-slate-400'} data-id="element-285">
                      {slot.ctr}%
                    </span>
                  </td>
                  <td className="py-2.5 px-2" data-id="element-286">
                    <div className="flex items-center gap-2" data-id="element-287">
                      <div className="w-16 bg-slate-100 rounded-full h-1.5" data-id="element-288">
                        <div className={`h-1.5 rounded-full ${slot.fillRate >= 80 ? 'bg-emerald-500' : slot.fillRate >= 40 ? 'bg-amber-500' : 'bg-rose-500'}`} style={{
                      width: `${slot.fillRate}%`
                    }} data-id="element-289" />
                      </div>
                      <span className="text-slate-500" data-id="element-290">{slot.fillRate}%</span>
                    </div>
                  </td>
                  <td className="py-2.5 px-2" data-id="element-291">
                    {slot.queue > 0 ? <Badge variant={slot.queue > 10 ? 'error' : 'warning'} size="sm" data-id="element-292">
                        {slot.queue}
                      </Badge> : <span className="text-slate-400" data-id="element-293">—</span>}
                  </td>
                  <td className="py-2.5 px-2" data-id="element-294">
                    {slot.lost > 0 ? <span className="text-rose-600 font-semibold" data-id="element-295">
                        {fmtCurrency(slot.lost)}
                      </span> : <span className="text-emerald-500" data-id="element-296">✓</span>}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </Card>

      {/* ═══ LOST REVENUE + FORECAST + UTILIZATION ═══ */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4" data-id="element-297">
        {/* Lost Revenue */}
        <Card padding="md" className="rounded-xl shadow-none border-slate-200" data-id="element-298">
          <SectionHeader title="Потерянный доход" icon={<AlertTriangle className="w-4 h-4 text-rose-500" data-id="element-300" />} tab="slots" buttonLabel="Слоты" data-id="element-299" />
          <p className="text-2xl font-bold text-rose-600 mb-4" data-id="element-301">
            {fmtCurrency(totalLostRevenue)}
          </p>
          <div className="space-y-2.5" data-id="element-302">
            {LOST_REVENUE.map(item => <div key={item.label} className="flex items-center justify-between cursor-pointer hover:bg-slate-50 rounded-lg p-1.5 -mx-1.5 transition-colors" onClick={() => openDrill(`Потери: ${item.label}`, 'lost_detail')} data-id="element-303">
                <div className="flex items-center gap-2" data-id="element-304">
                  <div className={`w-6 h-6 rounded-md ${item.color} flex items-center justify-center`} data-id="element-305">
                    {item.icon}
                  </div>
                  <span className="text-xs text-slate-600" data-id="element-306">{item.label}</span>
                </div>
                <span className="text-xs font-bold text-slate-900" data-id="element-307">
                  {fmtCurrency(item.value)}
                </span>
              </div>)}
          </div>
        </Card>

        {/* Revenue Forecast */}
        <Card padding="md" className="rounded-xl shadow-none border-slate-200" data-id="element-308">
          <SectionHeader title="Прогноз дохода" icon={<Zap className="w-4 h-4 text-amber-500" data-id="element-310" />} tab="queue" buttonLabel="Очередь" data-id="element-309" />
          <div className="space-y-3" data-id="element-311">
            <div className="flex justify-between items-center" data-id="element-312">
              <span className="text-xs text-slate-500" data-id="element-313">Текущий доход</span>
              <span className="text-sm font-bold text-slate-900" data-id="element-314">
                {fmtCurrency(totalRevenue)}
              </span>
            </div>
            <div className="w-full bg-slate-100 rounded-full h-3" data-id="element-315">
              <div className="bg-gradient-to-r from-emerald-500 to-emerald-400 h-3 rounded-full" style={{
              width: `${Math.round(totalRevenue / potentialRevenue * 100)}%`
            }} data-id="element-316" />
            </div>
            <div className="flex justify-between items-center" data-id="element-317">
              <span className="text-xs text-slate-500" data-id="element-318">Потенциал</span>
              <span className="text-sm font-bold text-indigo-600" data-id="element-319">
                {fmtCurrency(potentialRevenue)}
              </span>
            </div>
            <div className="border-t border-slate-100 pt-3 space-y-2" data-id="element-320">
              <div className="flex justify-between text-xs" data-id="element-321">
                <span className="text-slate-500" data-id="element-322">В очереди (деньги)</span>
                <span className="font-semibold text-slate-700" data-id="element-323">
                  {fmtCurrency(125000)}
                </span>
              </div>
              <div className="flex justify-between text-xs" data-id="element-324">
                <span className="text-slate-500" data-id="element-325">Запланировано</span>
                <span className="font-semibold text-slate-700" data-id="element-326">
                  {fmtCurrency(85000)}
                </span>
              </div>
              <div className="flex justify-between text-xs" data-id="element-327">
                <span className="text-slate-500" data-id="element-328">Ожидаемый доход</span>
                <span className="font-bold text-emerald-600" data-id="element-329">
                  {fmtCurrency(635800)}
                </span>
              </div>
            </div>
          </div>
        </Card>

        {/* Slot Utilization */}
        <Card padding="md" className="rounded-xl shadow-none border-slate-200" data-id="element-330">
          <SectionHeader title="Загрузка слотов" icon={<Target className="w-4 h-4 text-teal-500" data-id="element-332" />} tab="slots" buttonLabel="Все слоты" data-id="element-331" />
          <div className="text-center mb-4" data-id="element-333">
            <div className="text-4xl font-bold text-slate-900" data-id="element-334">{fillRate}%</div>
            <div className="text-xs text-slate-500" data-id="element-335">средний fill rate</div>
          </div>
          <div className="space-y-2.5" data-id="element-336">
            {[{
            label: 'Перегруженные',
            value: 2,
            color: 'text-rose-600',
            bg: 'bg-rose-50'
          }, {
            label: 'Нормальная загрузка',
            value: 4,
            color: 'text-emerald-600',
            bg: 'bg-emerald-50'
          }, {
            label: 'Недозагруженные',
            value: 3,
            color: 'text-amber-600',
            bg: 'bg-amber-50'
          }, {
            label: 'Пустые',
            value: 1,
            color: 'text-slate-500',
            bg: 'bg-slate-50'
          }, {
            label: 'Средняя очередь',
            value: 4.2,
            color: 'text-indigo-600',
            bg: 'bg-indigo-50'
          }].map(item => <div key={item.label} className="flex items-center justify-between cursor-pointer hover:bg-slate-50 rounded-lg p-1.5 -mx-1.5 transition-colors" onClick={() => openDrill(item.label, 'slot_util')} data-id="element-337">
                <span className="text-xs text-slate-600" data-id="element-338">{item.label}</span>
                <span className={`text-sm font-bold ${item.color}`} data-id="element-339">
                  {item.value}
                </span>
              </div>)}
          </div>
        </Card>
      </div>

      {/* ═══ TOP ADVERTISERS + TOP CAMPAIGNS ═══ */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4" data-id="element-340">
        {/* Top Advertisers */}
        <Card padding="md" className="rounded-xl shadow-none border-slate-200" data-id="element-341">
          <div className="flex items-center justify-between mb-4" data-id="element-342">
            <h3 className="text-sm font-bold text-slate-900 flex items-center gap-2" data-id="element-343">
              <Crown className="w-4 h-4 text-amber-500" data-id="element-344" /> ТОП рекламодателей
            </h3>
            <div className="flex items-center gap-2" data-id="element-345">
              <div className="flex gap-1" data-id="element-346">
                {([['revenue', 'Доход'], ['ctr', 'CTR'], ['conversions', 'Конв.']] as const).map(([key, label]) => <button key={key} onClick={() => setAdvSortBy(key)} className={`text-[10px] px-2 py-0.5 rounded-md font-medium transition-colors ${advSortBy === key ? 'bg-indigo-100 text-indigo-700' : 'text-slate-400 hover:text-slate-600'}`} data-id="element-347">
                    {label}
                  </button>)}
              </div>
              <Button variant="ghost" size="sm" className="text-xs text-indigo-600" onClick={() => openDrill('Все рекламодатели', 'advertisers')} data-id="element-348">
                Все <ExternalLink className="w-3 h-3 ml-1" data-id="element-349" />
              </Button>
            </div>
          </div>
          <div className="space-y-2" data-id="element-350">
            {sortedAdvertisers.map((a, i) => <div key={a.name} className="flex items-center gap-3 py-2 border-b border-slate-50 last:border-0 cursor-pointer hover:bg-slate-50 rounded-lg px-1.5 -mx-1.5 transition-colors" onClick={() => openDrill(`Рекламодатель: ${a.name}`, 'advertiser')} data-id="element-351">
                <span className="text-xs font-bold text-slate-400 w-4" data-id="element-352">
                  {i + 1}
                </span>
                <div className="flex-1 min-w-0" data-id="element-353">
                  <div className="text-xs font-medium text-slate-800 truncate" data-id="element-354">
                    {a.name}
                  </div>
                  <div className="text-[10px] text-slate-400" data-id="element-355">
                    {a.type} · {a.campaigns} кампаний
                  </div>
                </div>
                <div className="text-right shrink-0" data-id="element-356">
                  <div className="text-xs font-bold text-emerald-600" data-id="element-357">
                    {fmtCurrency(a.revenue)}
                  </div>
                  <div className="text-[10px] text-slate-400" data-id="element-358">CTR {a.ctr}%</div>
                </div>
              </div>)}
          </div>
        </Card>

        {/* Top Campaigns */}
        <Card padding="md" className="rounded-xl shadow-none border-slate-200" data-id="element-359">
          <div className="flex items-center justify-between mb-4" data-id="element-360">
            <h3 className="text-sm font-bold text-slate-900 flex items-center gap-2" data-id="element-361">
              <Star className="w-4 h-4 text-indigo-500" data-id="element-362" /> ТОП кампаний
            </h3>
            <div className="flex items-center gap-2" data-id="element-363">
              <div className="flex gap-1" data-id="element-364">
                {([['revenue', 'Доход'], ['ctr', 'CTR'], ['clicks', 'Клики']] as const).map(([key, label]) => <button key={key} onClick={() => setCampSortBy(key)} className={`text-[10px] px-2 py-0.5 rounded-md font-medium transition-colors ${campSortBy === key ? 'bg-indigo-100 text-indigo-700' : 'text-slate-400 hover:text-slate-600'}`} data-id="element-365">
                    {label}
                  </button>)}
              </div>
              <Button variant="ghost" size="sm" className="text-xs text-indigo-600" onClick={() => setActiveTab('all')} data-id="element-366">
                Все <ExternalLink className="w-3 h-3 ml-1" data-id="element-367" />
              </Button>
            </div>
          </div>
          <div className="space-y-2" data-id="element-368">
            {sortedCampaigns.map((c, i) => <div key={c.id} className="flex items-center gap-3 py-2 border-b border-slate-50 last:border-0 cursor-pointer hover:bg-slate-50 rounded-lg px-1.5 -mx-1.5 transition-colors" onClick={() => openDrill(`Кампания: ${c.name}`, 'campaign')} data-id="element-369">
                <span className="text-xs font-bold text-slate-400 w-4" data-id="element-370">
                  {i + 1}
                </span>
                <div className="flex-1 min-w-0" data-id="element-371">
                  <div className="text-xs font-medium text-slate-800 truncate" data-id="element-372">
                    {c.name}
                  </div>
                  <div className="text-[10px] text-slate-400" data-id="element-373">
                    {c.format} · {c.slot}
                  </div>
                </div>
                <div className="text-right shrink-0" data-id="element-374">
                  <div className="text-xs font-bold text-emerald-600" data-id="element-375">
                    {fmtCurrency(c.revenue)}
                  </div>
                  <div className="text-[10px] text-slate-400" data-id="element-376">
                    CTR {c.ctr}% · {fmtNum(c.clicks)} кл.
                  </div>
                </div>
              </div>)}
          </div>
        </Card>
      </div>

      {/* ═══ TOP ASTROLOGERS + WORST CAMPAIGNS ═══ */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4" data-id="element-377">
        {/* Top Astrologers */}
        <Card padding="md" className="rounded-xl shadow-none border-slate-200" data-id="element-378">
          <SectionHeader title="ТОП астрологов (реклама)" icon={<Star className="w-4 h-4 text-purple-500" data-id="element-380" />} tab="featured_astrologers" buttonLabel="Закреп астрологов" data-id="element-379" />
          <div className="space-y-2" data-id="element-381">
            {TOP_ASTROLOGERS.map((a, i) => <div key={a.name} className="flex items-center gap-3 py-2 border-b border-slate-50 last:border-0 cursor-pointer hover:bg-slate-50 rounded-lg px-1.5 -mx-1.5 transition-colors" onClick={() => openDrill(`Астролог: ${a.name}`, 'astrologer')} data-id="element-382">
                <span className="text-xs font-bold text-slate-400 w-4" data-id="element-383">
                  {i + 1}
                </span>
                <div className="flex-1 min-w-0" data-id="element-384">
                  <div className="text-xs font-medium text-slate-800" data-id="element-385">
                    {a.name}
                  </div>
                  <div className="text-[10px] text-slate-400" data-id="element-386">
                    {fmtNum(a.impressions)} показов · CTR {a.ctr}%
                  </div>
                </div>
                <div className="text-right shrink-0" data-id="element-387">
                  <div className="text-xs font-bold text-emerald-600" data-id="element-388">
                    {fmtCurrency(a.revenue)}
                  </div>
                  <div className="text-[10px] text-slate-400" data-id="element-389">
                    {a.bookings} записей · CR {a.cr}%
                  </div>
                </div>
              </div>)}
          </div>
        </Card>

        {/* Worst Campaigns */}
        <Card padding="md" className="rounded-xl shadow-none border-rose-200 bg-rose-50/30" data-id="element-390">
          <SectionHeader title="Проблемные кампании" icon={<AlertTriangle className="w-4 h-4 text-rose-500" data-id="element-392" />} tab="all" buttonLabel="Все размещения" data-id="element-391" />
          <div className="space-y-2" data-id="element-393">
            {WORST_CAMPAIGNS.map(c => {
            const cfg = severityConfig[c.severity];
            return <div key={c.id} className={`flex items-center justify-between gap-3 p-2.5 rounded-lg border bg-white ${cfg.border} cursor-pointer hover:shadow-sm transition-all`} onClick={() => openDrill(`Кампания: ${c.name}`, 'campaign')} data-id="element-394">
                  <div className="min-w-0" data-id="element-395">
                    <div className="flex items-center gap-2 mb-0.5" data-id="element-396">
                      <Badge variant={cfg.badge} size="sm" data-id="element-397">
                        {cfg.label}
                      </Badge>
                      <span className="text-xs font-medium text-slate-800 truncate" data-id="element-398">
                        {c.id}
                      </span>
                    </div>
                    <div className="text-[10px] text-slate-500 truncate" data-id="element-399">
                      {c.name} — {c.issue}
                    </div>
                  </div>
                  <Button variant="ghost" size="sm" className="shrink-0 text-xs" data-id="element-400">
                    Решить <ChevronRight className="w-3 h-3 ml-0.5" data-id="element-401" />
                  </Button>
                </div>;
          })}
          </div>
        </Card>
      </div>

      {/* ═══ CALENDAR ═══ */}
      <Card padding="md" className="rounded-xl shadow-none border-slate-200" data-id="element-402">
        <div className="flex flex-col gap-3 mb-4" data-id="element-403">
          {/* Calendar header with navigation */}
          <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3" data-id="element-404">
            <div className="flex items-center gap-3" data-id="element-405">
              <CalendarIcon className="w-4 h-4 text-indigo-500" data-id="element-406" />
              <div className="flex items-center gap-1" data-id="element-407">
                <button onClick={goToPrevMonth} className="p-1 rounded-md hover:bg-slate-100 text-slate-500 hover:text-slate-700 transition-colors" title="Предыдущий месяц" data-id="element-408">
                  <ChevronLeft className="w-4 h-4" data-id="element-409" />
                </button>
                <h3 className="text-sm font-bold text-slate-900 min-w-[180px] text-center" data-id="element-410">
                  Календарь размещений — {MONTH_NAMES[calendarMonth]}{' '}
                  {calendarYear}
                </h3>
                <button onClick={goToNextMonth} className="p-1 rounded-md hover:bg-slate-100 text-slate-500 hover:text-slate-700 transition-colors" title="Следующий месяц" data-id="element-411">
                  <ChevronRight className="w-4 h-4" data-id="element-412" />
                </button>
              </div>
              {!isCurrentMonth && <button onClick={goToCurrentMonth} className="text-[10px] text-indigo-600 hover:text-indigo-800 font-medium px-2 py-0.5 rounded-md bg-indigo-50 hover:bg-indigo-100 transition-colors" data-id="element-413">
                  Сегодня
                </button>}
            </div>

            {/* Calendar filter pills */}
            <div className="flex items-center gap-2" data-id="element-414">
              <div className="flex items-center gap-1 bg-slate-100 p-0.5 rounded-lg" data-id="element-415">
                {[{
                id: 'all' as const,
                label: 'Все',
                color: ''
              }, {
                id: 'active' as const,
                label: 'Активные',
                color: 'bg-emerald-500'
              }, {
                id: 'scheduled' as const,
                label: 'Запланировано',
                color: 'bg-amber-500'
              }, {
                id: 'email' as const,
                label: 'Email',
                color: 'bg-blue-500'
              }, {
                id: 'overloaded' as const,
                label: 'Перегрузка',
                color: 'bg-rose-500'
              }].map(f => <button key={f.id} onClick={() => setCalendarFilter(f.id)} className={`flex items-center gap-1 px-2 py-1 rounded-md text-[10px] font-medium transition-all ${calendarFilter === f.id ? 'bg-white text-slate-800 shadow-sm' : 'text-slate-500 hover:text-slate-700'}`} data-id="element-416">
                    {f.color && <div className={`w-1.5 h-1.5 rounded-full ${f.color}`} data-id="element-417" />}
                    {f.label}
                  </button>)}
              </div>
            </div>
          </div>

          {/* Legend */}
          <div className="flex items-center gap-4 text-[10px]" data-id="element-418">
            <div className="flex items-center gap-1.5" data-id="element-419">
              <div className="w-2 h-2 rounded-full bg-emerald-500" data-id="element-420" />
              <span className="text-slate-500" data-id="element-421">Активные</span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-422">
              <div className="w-2 h-2 rounded-full bg-amber-500" data-id="element-423" />
              <span className="text-slate-500" data-id="element-424">Запланировано</span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-425">
              <div className="w-2 h-2 rounded-full bg-blue-500" data-id="element-426" />
              <span className="text-slate-500" data-id="element-427">Email</span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-428">
              <div className="w-2 h-2 rounded-full bg-rose-500" data-id="element-429" />
              <span className="text-slate-500" data-id="element-430">Перегрузка</span>
            </div>
            <div className="ml-auto text-slate-400" data-id="element-431">
              {isCurrentMonth ? 'Данные за текущий месяц' : 'Нет данных за этот период (демо)'}
            </div>
          </div>
        </div>

        <div className="overflow-x-auto" data-id="element-432">
          <table className="w-full border-collapse min-w-[600px]" data-id="element-433">
            <thead data-id="element-434">
              <tr data-id="element-435">
                {['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'].map(d => <th key={d} className="p-1.5 text-center text-[10px] font-medium text-slate-400 border border-slate-100 bg-slate-50 w-[14.28%]" data-id="element-436">
                    {d}
                  </th>)}
              </tr>
            </thead>
            <tbody data-id="element-437">
              {(() => {
              const daysInMonth = getDaysInMonth(calendarMonth, calendarYear);
              const firstDay = getFirstDayOfWeek(calendarMonth, calendarYear);
              const weeks: (number | null)[][] = [];
              let week: (number | null)[] = Array(firstDay).fill(null);
              for (let d = 1; d <= daysInMonth; d++) {
                week.push(d);
                if (week.length === 7 || d === daysInMonth) {
                  while (week.length < 7) week.push(null);
                  weeks.push(week);
                  week = [];
                }
              }
              return weeks.map((w, wi) => <tr key={wi} data-id="element-438">
                    {w.map((day, di) => {
                  // Only show data for March 2026 (our mock data month)
                  const data = day && isCurrentMonth ? CALENDAR_DATA[day] : null;
                  const isFiltered = data && calendarFilter !== 'all' && (calendarFilter === 'active' && data.active === 0 || calendarFilter === 'scheduled' && data.scheduled === 0 || calendarFilter === 'email' && data.email === 0 || calendarFilter === 'overloaded' && !data.overloaded);
                  return <td key={di} className={`border border-slate-100 p-1.5 h-16 align-top text-center ${day ? 'cursor-pointer hover:bg-indigo-50/50 transition-colors' : 'bg-slate-50/50'} ${data?.overloaded && (calendarFilter === 'all' || calendarFilter === 'overloaded') ? 'bg-rose-50/50' : ''} ${isFiltered ? 'opacity-30' : ''}`} onClick={() => day && isCurrentMonth && openDrill(`Размещения: ${day} ${MONTH_NAMES[calendarMonth]}`, 'calendar_day')} data-id="element-439">
                          {day && <>
                              <div className={`text-xs font-medium mb-1 ${data?.overloaded && !isFiltered ? 'text-rose-600' : 'text-slate-700'}`} data-id="element-440">
                                {day}
                              </div>
                              {data && !isFiltered && <div className="flex justify-center gap-0.5 flex-wrap" data-id="element-441">
                                  {data.active > 0 && (calendarFilter === 'all' || calendarFilter === 'active') && <div className="w-1.5 h-1.5 rounded-full bg-emerald-500" title={`${data.active} активных`} data-id="element-442" />}
                                  {data.scheduled > 0 && (calendarFilter === 'all' || calendarFilter === 'scheduled') && <div className="w-1.5 h-1.5 rounded-full bg-amber-500" title={`${data.scheduled} запланировано`} data-id="element-443" />}
                                  {data.email > 0 && (calendarFilter === 'all' || calendarFilter === 'email') && <div className="w-1.5 h-1.5 rounded-full bg-blue-500" title={`${data.email} email`} data-id="element-444" />}
                                  {data.overloaded && (calendarFilter === 'all' || calendarFilter === 'overloaded') && <div className="w-1.5 h-1.5 rounded-full bg-rose-500" title="Перегрузка" data-id="element-445" />}
                                </div>}
                              {data && isFiltered && calendarFilter !== 'all' && <div className="flex justify-center gap-0.5 flex-wrap" data-id="element-446">
                                    {/* Show muted dots for non-matching days */}
                                  </div>}
                            </>}
                        </td>;
                })}
                  </tr>);
            })()}
            </tbody>
          </table>
        </div>

        {/* Calendar summary */}
        {isCurrentMonth && <div className="mt-3 pt-3 border-t border-slate-100 flex flex-wrap gap-4" data-id="element-447">
            <div className="flex items-center gap-2 text-xs" data-id="element-448">
              <span className="text-slate-500" data-id="element-449">Всего дней с размещениями:</span>
              <span className="font-bold text-slate-900" data-id="element-450">
                {Object.keys(CALENDAR_DATA).length}
              </span>
            </div>
            <div className="flex items-center gap-2 text-xs" data-id="element-451">
              <span className="text-slate-500" data-id="element-452">Дней с перегрузкой:</span>
              <span className="font-bold text-rose-600" data-id="element-453">
                {Object.values(CALENDAR_DATA).filter(d => d.overloaded).length}
              </span>
            </div>
            <div className="flex items-center gap-2 text-xs" data-id="element-454">
              <span className="text-slate-500" data-id="element-455">Email рассылки:</span>
              <span className="font-bold text-blue-600" data-id="element-456">
                {Object.values(CALENDAR_DATA).filter(d => d.email > 0).length}
              </span>
            </div>
            <div className="ml-auto" data-id="element-457">
              <Button variant="ghost" size="sm" className="text-xs text-indigo-600" onClick={() => setActiveTab('all')} data-id="element-458">
                Все размещения <ExternalLink className="w-3 h-3 ml-1" data-id="element-459" />
              </Button>
            </div>
          </div>}
      </Card>

      {/* ═══ EXPORT BAR ═══ */}
      <Card padding="md" className="rounded-xl shadow-none border-slate-200" data-id="element-460">
        <div className="flex flex-col gap-3" data-id="element-461">
          <div className="flex flex-wrap items-center justify-between gap-3" data-id="element-462">
            <div className="flex items-center gap-3" data-id="element-463">
              <Download className="w-4 h-4 text-slate-500" data-id="element-464" />
              <div data-id="element-465">
                <span className="text-xs font-medium text-slate-700" data-id="element-466">
                  Экспорт аналитики рекламы
                </span>
                <p className="text-[10px] text-slate-400" data-id="element-467">
                  Период:{' '}
                  {periods.find(p => p.id === filters.period)?.label || '30 дней'}{' '}
                  · Формат: {filters.type === 'all' ? 'Все типы' : filters.type}
                </p>
              </div>
            </div>
            <div className="flex gap-2" data-id="element-468">
              {[{
              id: 'csv',
              label: 'CSV',
              icon: <FileText className="w-3.5 h-3.5" data-id="element-469" />
            }, {
              id: 'xlsx',
              label: 'XLSX',
              icon: <FileText className="w-3.5 h-3.5" data-id="element-470" />
            }, {
              id: 'pdf',
              label: 'PDF',
              icon: <FileText className="w-3.5 h-3.5" data-id="element-471" />
            }].map(fmt => <Button key={fmt.id} variant="outline" size="sm" disabled={exportLoading !== null} icon={exportLoading === fmt.id ? <Loader2 className="w-3.5 h-3.5 animate-spin" data-id="element-473" /> : fmt.icon} onClick={() => handleExport(fmt.id)} data-id="element-472">
                  {exportLoading === fmt.id ? 'Экспорт...' : fmt.label}
                </Button>)}
              <div className="w-px bg-slate-200 mx-1" data-id="element-474" />
              <Button variant="outline" size="sm" icon={<Mail className="w-3.5 h-3.5" data-id="element-476" />} onClick={() => setShowScheduleModal(true)} data-id="element-475">
                Запланировать
              </Button>
            </div>
          </div>

          {/* Export progress */}
          {exportLoading && <div className="flex items-center gap-3 bg-indigo-50 border border-indigo-100 rounded-lg p-2.5" data-id="element-477">
              <Loader2 className="w-4 h-4 text-indigo-600 animate-spin shrink-0" data-id="element-478" />
              <div className="flex-1" data-id="element-479">
                <div className="text-xs font-medium text-indigo-700" data-id="element-480">
                  Формирование отчёта {exportLoading.toUpperCase()}...
                </div>
                <div className="w-full bg-indigo-100 rounded-full h-1.5 mt-1.5" data-id="element-481">
                  <div className="bg-indigo-500 h-1.5 rounded-full animate-pulse" style={{
                width: '65%'
              }} data-id="element-482" />
                </div>
              </div>
              <button onClick={() => setExportLoading(null)} className="text-xs text-indigo-500 hover:text-indigo-700" data-id="element-483">
                Отмена
              </button>
            </div>}
        </div>
      </Card>

      {/* ═══ SCHEDULE EXPORT MODAL ═══ */}
      {showScheduleModal && <div className="fixed inset-0 z-[100] flex items-center justify-center bg-slate-900/50 backdrop-blur-sm p-4" onClick={e => {
      if (e.target === e.currentTarget) setShowScheduleModal(false);
    }} data-id="element-484">
          <Card className="w-full max-w-md shadow-2xl overflow-hidden" padding="none" data-id="element-485">
            <div className="flex items-center justify-between p-4 border-b border-slate-200 bg-slate-50" data-id="element-486">
              <div className="flex items-center gap-2" data-id="element-487">
                <CalendarIcon className="w-5 h-5 text-indigo-600" data-id="element-488" />
                <h3 className="font-bold text-slate-900 text-sm" data-id="element-489">
                  Запланировать отчёт
                </h3>
              </div>
              <button onClick={() => setShowScheduleModal(false)} className="p-1.5 text-slate-400 hover:text-slate-600 rounded-lg hover:bg-slate-100" data-id="element-490">
                <X className="w-5 h-5" data-id="element-491" />
              </button>
            </div>
            <div className="p-5 space-y-4" data-id="element-492">
              <div data-id="element-493">
                <label className="block text-xs font-medium text-slate-700 mb-1.5" data-id="element-494">
                  Частота
                </label>
                <div className="flex gap-2" data-id="element-495">
                  {[{
                id: 'daily',
                label: 'Ежедневно'
              }, {
                id: 'weekly',
                label: 'Еженедельно'
              }, {
                id: 'monthly',
                label: 'Ежемесячно'
              }].map(f => <button key={f.id} onClick={() => setScheduleConfig(c => ({
                ...c,
                frequency: f.id
              }))} className={`flex-1 px-3 py-2 rounded-lg text-xs font-medium border transition-all ${scheduleConfig.frequency === f.id ? 'bg-indigo-50 border-indigo-300 text-indigo-700' : 'border-slate-200 text-slate-500 hover:border-slate-300'}`} data-id="element-496">
                      {f.label}
                    </button>)}
                </div>
              </div>

              {scheduleConfig.frequency === 'weekly' && <div data-id="element-497">
                  <label className="block text-xs font-medium text-slate-700 mb-1.5" data-id="element-498">
                    День недели
                  </label>
                  <select className="w-full text-xs border border-slate-200 rounded-lg px-3 py-2 bg-white text-slate-700 focus:outline-none focus:ring-1 focus:ring-indigo-500" value={scheduleConfig.day} onChange={e => setScheduleConfig(c => ({
              ...c,
              day: e.target.value
            }))} data-id="element-499">
                    <option value="monday" data-id="element-500">Понедельник</option>
                    <option value="tuesday" data-id="element-501">Вторник</option>
                    <option value="wednesday" data-id="element-502">Среда</option>
                    <option value="thursday" data-id="element-503">Четверг</option>
                    <option value="friday" data-id="element-504">Пятница</option>
                  </select>
                </div>}

              <div data-id="element-505">
                <label className="block text-xs font-medium text-slate-700 mb-1.5" data-id="element-506">
                  Формат файла
                </label>
                <div className="flex gap-2" data-id="element-507">
                  {['csv', 'xlsx', 'pdf'].map(f => <button key={f} onClick={() => setScheduleConfig(c => ({
                ...c,
                format: f
              }))} className={`flex-1 px-3 py-2 rounded-lg text-xs font-medium border transition-all uppercase ${scheduleConfig.format === f ? 'bg-indigo-50 border-indigo-300 text-indigo-700' : 'border-slate-200 text-slate-500 hover:border-slate-300'}`} data-id="element-508">
                      {f}
                    </button>)}
                </div>
              </div>

              <div data-id="element-509">
                <label className="block text-xs font-medium text-slate-700 mb-1.5" data-id="element-510">
                  Email для отправки
                </label>
                <input type="email" className="w-full text-xs border border-slate-200 rounded-lg px-3 py-2 bg-white text-slate-700 focus:outline-none focus:ring-1 focus:ring-indigo-500" value={scheduleConfig.email} onChange={e => setScheduleConfig(c => ({
              ...c,
              email: e.target.value
            }))} data-id="element-511" />
              </div>

              <div className="bg-slate-50 rounded-lg p-3 text-[10px] text-slate-500" data-id="element-512">
                <p className="font-medium text-slate-600 mb-1" data-id="element-513">
                  Что будет в отчёте:
                </p>
                <ul className="space-y-0.5 list-disc list-inside" data-id="element-514">
                  <li data-id="element-515">KPI метрики (доход, показы, клики, CTR)</li>
                  <li data-id="element-516">Топ кампаний и рекламодателей</li>
                  <li data-id="element-517">Анализ слотов и fill rate</li>
                  <li data-id="element-518">Потерянный доход и рекомендации</li>
                </ul>
              </div>
            </div>
            <div className="p-4 border-t border-slate-200 bg-slate-50 flex justify-end gap-2" data-id="element-519">
              <Button variant="ghost" size="sm" onClick={() => setShowScheduleModal(false)} data-id="element-520">
                Отмена
              </Button>
              <Button variant="primary" size="sm" icon={<Check className="w-3.5 h-3.5" data-id="element-522" />} onClick={handleScheduleExport} data-id="element-521">
                Запланировать
              </Button>
            </div>
          </Card>
        </div>}

      {/* ═══ DRILL-DOWN MODAL ═══ */}
      {drillDown && <div className="fixed inset-0 z-[100] flex items-center justify-center bg-slate-900/50 backdrop-blur-sm p-4" onClick={e => {
      if (e.target === e.currentTarget) setDrillDown(null);
    }} data-id="element-523">
          <Card className="w-full max-w-3xl max-h-[80vh] flex flex-col shadow-2xl overflow-hidden" padding="none" data-id="element-524">
            <div className="flex items-center justify-between p-4 border-b border-slate-200 bg-slate-50 shrink-0" data-id="element-525">
              <div className="flex items-center gap-2" data-id="element-526">
                <BarChart3 className="w-5 h-5 text-indigo-600" data-id="element-527" />
                <h3 className="font-bold text-slate-900 text-sm" data-id="element-528">
                  {drillDown.title}
                </h3>
              </div>
              <button onClick={() => setDrillDown(null)} className="p-1.5 text-slate-400 hover:text-slate-600 rounded-lg hover:bg-slate-100" data-id="element-529">
                <X className="w-5 h-5" data-id="element-530" />
              </button>
            </div>
            <div className="flex-1 overflow-y-auto p-5" data-id="element-531">
              <p className="text-xs text-slate-500 mb-4" data-id="element-532">
                Детализация по запросу «{drillDown.title}»
              </p>
              <div className="overflow-x-auto" data-id="element-533">
                <table className="w-full text-xs" data-id="element-534">
                  <thead data-id="element-535">
                    <tr className="border-b border-slate-200" data-id="element-536">
                      <th className="text-left py-2 px-3 text-slate-500 font-medium" data-id="element-537">
                        ID
                      </th>
                      <th className="text-left py-2 px-3 text-slate-500 font-medium" data-id="element-538">
                        Кампания
                      </th>
                      <th className="text-left py-2 px-3 text-slate-500 font-medium" data-id="element-539">
                        Формат
                      </th>
                      <th className="text-right py-2 px-3 text-slate-500 font-medium" data-id="element-540">
                        Показы
                      </th>
                      <th className="text-right py-2 px-3 text-slate-500 font-medium" data-id="element-541">
                        Клики
                      </th>
                      <th className="text-right py-2 px-3 text-slate-500 font-medium" data-id="element-542">
                        CTR
                      </th>
                      <th className="text-right py-2 px-3 text-slate-500 font-medium" data-id="element-543">
                        Доход
                      </th>
                    </tr>
                  </thead>
                  <tbody data-id="element-544">
                    {TOP_CAMPAIGNS.map(c => <tr key={c.id} className="border-b border-slate-50 hover:bg-slate-50" data-id="element-545">
                        <td className="py-2 px-3 font-mono text-indigo-600" data-id="element-546">
                          {c.id}
                        </td>
                        <td className="py-2 px-3 font-medium text-slate-800" data-id="element-547">
                          {c.name}
                        </td>
                        <td className="py-2 px-3 text-slate-500" data-id="element-548">{c.format}</td>
                        <td className="py-2 px-3 text-right text-slate-600" data-id="element-549">
                          {fmtNum(c.impressions)}
                        </td>
                        <td className="py-2 px-3 text-right text-slate-600" data-id="element-550">
                          {fmtNum(c.clicks)}
                        </td>
                        <td className="py-2 px-3 text-right font-semibold" data-id="element-551">
                          {c.ctr}%
                        </td>
                        <td className="py-2 px-3 text-right font-bold text-emerald-600" data-id="element-552">
                          {fmtCurrency(c.revenue)}
                        </td>
                      </tr>)}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="p-3 border-t border-slate-200 bg-slate-50 flex justify-end gap-2 shrink-0" data-id="element-553">
              <Button variant="outline" size="sm" onClick={() => success('Данные экспортированы')} data-id="element-554">
                Экспорт
              </Button>
              <Button variant="ghost" size="sm" onClick={() => setDrillDown(null)} data-id="element-555">
                Закрыть
              </Button>
            </div>
          </Card>
        </div>}
    </div>;
}